export class UserModel {
  username: string;
  password: string;
  questionToken: string;
  questionAnswer: string;
  pin: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/userModel.ts